<template>
    <div ref="table" class="tabulator-container"></div>
  </template>

<script setup>
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getScoreListData,getScoreSignalData,displayDate, getScoreMore } from '@/api/chart/scoreApi';
const table = ref(null);
const tabulator = ref(null);
const tableData = reactive([]);
let result = ref();
let copyResult = ref();
let signal_result = ref();
let scoreMoreList = ref();
const router = useRouter();
onMounted(async() => {
    result.value = await getScoreListData();
    signal_result.value = await getScoreSignalData();
    result.value.forEach(resultArray => {
        let signalArray = signal_result.value.find(data => data.ticker == resultArray.symbol)
        resultArray.signal = signalArray.signal
        resultArray.fixed_signal = signalArray.fixed_signal
        resultArray.signal_time = displayDate(signalArray.datetime)
    })
    copyResult.value = [...result.value];
    // console.log('score list value',result.value);

    scoreMoreList.value = await getScoreMore();
    // console.log('scoreMoreList.value',scoreMoreList.value);
    tableData.value = copyResult.value
    // console.log('tableData.value',tableData.value);
    const tableSet = new Tabulator(table.value, {
        data: tableData.value, // 表示データ
        reactiveData: true, //
        layout: "fitColumns", //
        resizableColumnFit: true, //
        // headerVisible: false, //ヘッダーを非表示
        // height: "211px", // テーブルの高さ指定
        movableRows: true, // 行のドラッグ&ドロップを可能にする
        movableColumns: true, // 列のドラッグ&ドロップを可能にする
        frozenRows: 1, // 先頭行から指定した行数を固定
        // pagination: "local",
        // paginationSize: 10, // ページネーションのデフォルトサイズ指定
        // paginationSizeSelector: [2, 10, 25, 50, 100], // ページネーションの選択できるサイズ指定
        // paginationCounter: "rows", // ページネーションのカウンターを表示
        columns: [
        {
            title: "Coin",
            field: "symbol", // 'market' 대신 'symbol'을 사용
            width: 230,
            hozAlign: "left",
            resizable: true,
            cellClick: (e, cell) => {
            if (!e.target.classList.contains("star")) {
                const data = cell.getData();
                router.push(`/kibot/chart`, { query: { menuName: "meta", ticker: data.symbol }}); // 'market' -> 'symbol'
                return;
            }

            const coinName = cell.getValue();
            if (e.target.classList.contains("active")) {
                e.target.classList.remove("active");
            } else {
                e.target.classList.add("active");
            }
            // setFavoriteCoinList({ coinName, withSuffix: false });
            },
            // headerClick: coinHeaderHandler
        },
        {
            visible: true,
            title: "Current Price",
            field: "c_price", // 매핑: 'c_price'
            width: 200,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: true,
            title: "Previous Price",
            field: "p_price", // 매핑: 'p_price'
            width: 200,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: true,
            title: "Fluctuating Price",
            field: "f_price", // 매핑: 'f_price'
            width: 208,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: false,
            title: "Current Score",
            field: "c_score", // 매핑: 'c_score'
            width: 200,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: false,
            title: "Previous Score",
            field: "p_score", // 매핑: 'p_score'
            width: 200,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: false,
            title: "Fluctuating Score",
            field: "f_score", // 매핑: 'f_score'
            width: 208,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: false,
            title: "Current",
            field: "current", // 매핑: 'current' -> 계산에 사용
            width: 200,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: false,
            title: "Previous",
            field: "previous", // 매핑: 'previous' -> 계산에 사용
            width: 200,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: false,
            title: "Fluctuating",
            field: "fluctuating", // 매핑: 'fluctuating' -> 계산에 사용
            width: 208,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: true,
            title: "Percent Price",
            field: "p_percent", // 매핑: 'p_percent'
            width: 150,
            hozAlign: "right",
            resizable: true,
        },
        {
            visible: false,
            title: "Percent Score",
            field: "s_percent", // 매핑: 's_percent'
            width: 150,
            hozAlign: "right",
            resizable: true,
        },
        {
            title: "Fixed",
            field: "fixed_signal", // 매핑: 'fixed_signal'
            width: 95,
            hozAlign: "center",
            resizable: true,
        },
        {
            title: "Live",
            field: "signal_time", // 매핑: 'signal_time'
            width: 220,
            hozAlign: "left",
            resizable: true,
            // headerTap: timeHeaderClickHandler,
            // headerClick: timeHeaderClickHandler
        },
        {
            title: "Chart",
            field: "chart", // 별도로 처리 필요
            width: 100,
            hozAlign: "center",
            resizable: true,
            headerSort: false,
            cellClick: (e, cell) => {
            const data = cell.getData();
            router.push(`/kibot/chart`, { query: { menuName: "meta", ticker: data.symbol }}); // 'market' -> 'symbol'
            }
        },
        { visible: false, field: "moreThan6" },
        { visible: false, field: "position" }
        ]
    });
    // //listen for row move
    // tableSet.on("rowMoved", function (row) {
    //     console.log("Row: " + row.getData().name + " has been moved");
    // });
    tabulator.value = tableSet;
});
</script>

<style lang='scss' scoped>
@import "tabulator-tables/dist/css/tabulator.min.css";
@import "@/assets/scss/plugin/tabulator/tabulator.scss";
</style>